import { render, staticRenderFns } from "./kyc_step_one.vue?vue&type=template&id=32d5d0e4&scoped=true"
import script from "./kyc_step_one.vue?vue&type=script&lang=js"
export * from "./kyc_step_one.vue?vue&type=script&lang=js"
import style0 from "./kyc_step_one.vue?vue&type=style&index=0&id=32d5d0e4&prod&scoped=true&lang=css"
import style1 from "./kyc_step_one.vue?vue&type=style&index=1&id=32d5d0e4&prod&lang=css"
import style2 from "./kyc_step_one.vue?vue&type=style&index=2&id=32d5d0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d5d0e4",
  null
  
)

export default component.exports